// extracted by mini-css-extract-plugin
export default {"colorRampForm":"ColorRampForm_colorRampForm__QzvAa"};